<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kEEGFk/media/FC-9781035858545.jpg?1718732527213" alt="This image is the cover for the book Daisy Chain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Daisy Chain
      </h1>
      <p class="bookDescription body article font2">
        <p>As her ninety-fifth year draws to a close, Margaret’s light begins to fade. With her last wish and legacy in mind, she pins all her hopes on a much younger generation, seeking to bridge the gap between two vastly different stages of life. Joshua and Abigail, at the opposite end of life’s spectrum, find themselves unexpectedly intertwined with Margaret’s final journey. As they strive to fulfil her dying wish, they are forced to confront their own demons and embark on a path of self-discovery. Will their efforts to help Margaret ultimately lead them to find themselves, or will their struggles be lost in the dwindling sands of time? Amidst the turmoil, the question of forgiveness looms large. Can long-standing nemeses be forgiven, and can the weight of the past be lifted? As Margaret, Joshua, and Abigail navigate this emotional landscape, they each seek the serenity that has eluded them for so long.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Antonina Irena Brzozowska
      </h2>
      
      <p class="authorDescription body article">Antonina Irena Brzozowska was born and educated in the north-east of England. A former teacher, her interests incorporate the Polish, Canadian, and Hawaiian cultures and traditions. Her extensive travel experiences in these countries have provided her with an invaluable asset to her writing.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?75cc188f